import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, renderList as _renderList, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  ref: "modalEl",
  class: "modal fade",
  tabindex: "-1",
  "aria-labelledby": "apmTitle",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { class: "apm-grid" }
const _hoisted_6 = {
  class: "apm-mode",
  "aria-labelledby": "apm-manual"
}
const _hoisted_7 = { class: "apm-block" }
const _hoisted_8 = { class: "apm-block-body" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-5",
  role: "status"
}
const _hoisted_11 = {
  key: 1,
  class: "ph ph-plus me-5",
  "aria-hidden": "true"
}
const _hoisted_12 = { class: "apm-block" }
const _hoisted_13 = { class: "apm-block-body" }
const _hoisted_14 = {
  key: 0,
  class: "text-muted d-block mt-5"
}
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-5",
  role: "status"
}
const _hoisted_17 = {
  key: 1,
  class: "ph ph-play me-5",
  "aria-hidden": "true"
}
const _hoisted_18 = {
  class: "apm-mode",
  "aria-labelledby": "apm-auto"
}
const _hoisted_19 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_20 = {
  class: "apm-days",
  role: "group",
  "aria-labelledby": "apm-days"
}
const _hoisted_21 = ["aria-pressed", "title", "onClick"]
const _hoisted_22 = {
  key: 0,
  class: "apm-err"
}
const _hoisted_23 = { class: "apm-time" }
const _hoisted_24 = {
  key: 1,
  class: "apm-err"
}
const _hoisted_25 = {
  key: 2,
  class: "text-muted d-block mt-5"
}
const _hoisted_26 = { class: "form-check form-switch apm-switch mt-15" }
const _hoisted_27 = {
  class: "form-check-label",
  for: "apm-active"
}
const _hoisted_28 = ["disabled"]
const _hoisted_29 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-5",
  role: "status"
}
const _hoisted_30 = {
  key: 1,
  class: "ph ph-floppy-disk me-5",
  "aria-hidden": "true"
}
const _hoisted_31 = { class: "apm-banner mt-15" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { key: 2 }
const _hoisted_35 = {
  key: 3,
  class: "text-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[30] || (_cache[30] = _createElementVNode("div", { class: "modal-header" }, [
          _createElementVNode("div", null, [
            _createElementVNode("h2", {
              id: "apmTitle",
              class: "modal-title fs-5"
            }, "Création des bons de paiement livreurs"),
            _createElementVNode("small", { class: "text-muted" }, "Deux modes pour créer un bon par livreur.")
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Fermer"
          })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("section", _hoisted_6, [
              _cache[18] || (_cache[18] = _createElementVNode("header", { class: "apm-mode-head" }, [
                _createElementVNode("span", { class: "apm-num" }, "01"),
                _createElementVNode("div", null, [
                  _createElementVNode("h3", { id: "apm-manual" }, "Mode manuel"),
                  _createElementVNode("p", null, "Déclencher la création à la demande")
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_7, [
                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "apm-block-head" }, [
                  _createElementVNode("span", { class: "apm-letter" }, "A"),
                  _createElementVNode("div", null, [
                    _createElementVNode("h4", null, "Ajout individuel"),
                    _createElementVNode("p", null, "Créer le bon du livreur sélectionné.")
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_8, [
                  _cache[11] || (_cache[11] = _createElementVNode("label", {
                    class: "apm-label",
                    for: "apm-ind-agency"
                  }, "Agence", -1)),
                  _createVNode(_component_v_select, {
                    modelValue: _ctx.indAgency,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.indAgency) = $event)),
                    "input-id": "apm-ind-agency",
                    class: "custom-select-height mb-10",
                    options: _ctx.agencies,
                    label: "name",
                    placeholder: "Choisir une agence"
                  }, null, 8, ["modelValue", "options"]),
                  _cache[12] || (_cache[12] = _createElementVNode("label", {
                    class: "apm-label",
                    for: "apm-ind-driver"
                  }, "Livreur", -1)),
                  _createVNode(_component_v_select, {
                    modelValue: _ctx.indDriver,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.indDriver) = $event)),
                    "input-id": "apm-ind-driver",
                    class: "custom-select-height",
                    options: _ctx.indDrivers,
                    "get-option-label": _ctx.driverLabel,
                    loading: _ctx.indLoading,
                    disabled: !_ctx.indAgency,
                    placeholder: "Sélectionner un livreur"
                  }, {
                    "no-options": _withCtx(() => _cache[9] || (_cache[9] = [
                      _createTextVNode("Aucun livreur avec des colis à payer dans cette agence.", -1)
                    ])),
                    _: 1
                  }, 8, ["modelValue", "options", "get-option-label", "loading", "disabled"]),
                  _cache[13] || (_cache[13] = _createElementVNode("small", { class: "text-muted d-block mt-5" }, "Seuls les livreurs ayant des colis à payer sont proposés.", -1)),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn apm-btn-blue w-100 mt-10",
                    disabled: !_ctx.indDriver || !!_ctx.busy,
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.createIndividual && _ctx.createIndividual(...args)))
                  }, [
                    (_ctx.busy === 'ind')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10))
                      : (_openBlock(), _createElementBlock("i", _hoisted_11)),
                    _cache[10] || (_cache[10] = _createTextVNode("Ajouter ", -1))
                  ], 8, _hoisted_9)
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _cache[17] || (_cache[17] = _createElementVNode("div", { class: "apm-block-head" }, [
                  _createElementVNode("span", { class: "apm-letter" }, "B"),
                  _createElementVNode("div", null, [
                    _createElementVNode("h4", null, "Ajout groupé"),
                    _createElementVNode("p", null, "Créer un bon pour chaque livreur de cette agence.")
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_13, [
                  _cache[16] || (_cache[16] = _createElementVNode("label", {
                    class: "apm-label",
                    for: "apm-grp-agency"
                  }, "Agence", -1)),
                  _createVNode(_component_v_select, {
                    modelValue: _ctx.grpAgency,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.grpAgency) = $event)),
                    "input-id": "apm-grp-agency",
                    class: "custom-select-height",
                    options: _ctx.agencies,
                    label: "name",
                    placeholder: "Choisir une agence"
                  }, null, 8, ["modelValue", "options"]),
                  (_ctx.grpAgency)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_14, [
                        (_ctx.grpLoading)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode("Calcul…")
                            ], 64))
                          : (_ctx.grpEligible.length)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(_ctx.grpEligible.length) + " livreur(s) · " + _toDisplayString(_ctx.grpParcels) + " colis à payer ", 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createTextVNode("Aucun livreur avec des colis à payer dans cette agence.")
                              ], 64))
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary w-100 mt-10",
                    disabled: !_ctx.grpAgency || !_ctx.grpEligible.length || !!_ctx.busy,
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.createGrouped && _ctx.createGrouped(...args)))
                  }, [
                    (_ctx.busy === 'grp')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16))
                      : (_openBlock(), _createElementBlock("i", _hoisted_17)),
                    _cache[15] || (_cache[15] = _createTextVNode("Auto Add ", -1))
                  ], 8, _hoisted_15)
                ])
              ])
            ]),
            _createElementVNode("section", _hoisted_18, [
              _cache[28] || (_cache[28] = _createElementVNode("header", { class: "apm-mode-head" }, [
                _createElementVNode("span", { class: "apm-num" }, "02"),
                _createElementVNode("div", null, [
                  _createElementVNode("h3", { id: "apm-auto" }, "Mode automatique"),
                  _createElementVNode("p", null, "Planifier la création sans intervention")
                ])
              ], -1)),
              (_ctx.scheduleLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, _cache[19] || (_cache[19] = [
                    _createElementVNode("span", { class: "spinner-border spinner-border-sm" }, null, -1)
                  ])))
                : (_openBlock(), _createElementBlock("form", {
                    key: 1,
                    class: "apm-auto",
                    novalidate: "",
                    onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveSchedule && _ctx.saveSchedule(...args)), ["prevent"]))
                  }, [
                    _cache[24] || (_cache[24] = _createElementVNode("label", {
                      class: "apm-label",
                      for: "apm-auto-agency"
                    }, "Agences", -1)),
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.schedule.agency,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.schedule.agency) = $event)),
                      "input-id": "apm-auto-agency",
                      class: "custom-select-height",
                      options: _ctx.agencyOptionsAll,
                      label: "name",
                      clearable: false
                    }, null, 8, ["modelValue", "options"]),
                    _cache[25] || (_cache[25] = _createElementVNode("small", { class: "text-muted d-block mt-5" }, "Une agence ou toutes les agences", -1)),
                    _cache[26] || (_cache[26] = _createElementVNode("label", {
                      class: "apm-label mt-15",
                      id: "apm-days"
                    }, "Jours de création", -1)),
                    _createElementVNode("div", _hoisted_20, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekDays, (d) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: d.value,
                          type: "button",
                          class: _normalizeClass({ 'is-on': _ctx.schedule.days.includes(d.value) }),
                          "aria-pressed": _ctx.schedule.days.includes(d.value),
                          title: d.full,
                          onClick: ($event: any) => (_ctx.toggleDay(d.value))
                        }, _toDisplayString(d.short), 11, _hoisted_21))
                      }), 128))
                    ]),
                    (_ctx.scheduleErrors.days)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.scheduleErrors.days), 1))
                      : _createCommentVNode("", true),
                    _cache[27] || (_cache[27] = _createElementVNode("label", {
                      class: "apm-label mt-15",
                      for: "apm-time"
                    }, "Heure de création", -1)),
                    _createElementVNode("div", _hoisted_23, [
                      _cache[20] || (_cache[20] = _createElementVNode("i", {
                        class: "ph ph-clock",
                        "aria-hidden": "true"
                      }, null, -1)),
                      _withDirectives(_createElementVNode("input", {
                        id: "apm-time",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.schedule.run_time) = $event)),
                        type: "time",
                        class: "form-control",
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.schedule.run_time]
                      ])
                    ]),
                    (_ctx.scheduleErrors.run_time)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.scheduleErrors.run_time), 1))
                      : (_openBlock(), _createElementBlock("small", _hoisted_25, "Heure du Maroc")),
                    _createElementVNode("div", _hoisted_26, [
                      _withDirectives(_createElementVNode("input", {
                        id: "apm-active",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.schedule.active) = $event)),
                        class: "form-check-input",
                        type: "checkbox",
                        role: "switch"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.schedule.active]
                      ]),
                      _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.schedule.active ? "Planification activée" : "Planification désactivée"), 1)
                    ]),
                    _createElementVNode("button", {
                      type: "submit",
                      class: "btn apm-btn-blue w-100 mt-15",
                      disabled: _ctx.savingSchedule
                    }, [
                      (_ctx.savingSchedule)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_29))
                        : (_openBlock(), _createElementBlock("i", _hoisted_30)),
                      _cache[21] || (_cache[21] = _createTextVNode("Enregistrer la planification ", -1))
                    ], 8, _hoisted_28),
                    _createElementVNode("div", _hoisted_31, [
                      _cache[23] || (_cache[23] = _createElementVNode("i", {
                        class: "ph ph-calendar-dots",
                        "aria-hidden": "true"
                      }, null, -1)),
                      _createElementVNode("div", null, [
                        _cache[22] || (_cache[22] = _createElementVNode("strong", null, "Création aux jours et à l'heure définis.", -1)),
                        (_ctx.saved.active && _ctx.saved.next_run)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_32, "Prochaine création : " + _toDisplayString(_ctx.dateTime(_ctx.saved.next_run)), 1))
                          : (_openBlock(), _createElementBlock("small", _hoisted_33, "Planification désactivée : aucune création automatique.")),
                        (_ctx.saved.last_run_at)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_34, " Dernière exécution : " + _toDisplayString(_ctx.dateTime(_ctx.saved.last_run_at)) + " — " + _toDisplayString(_ctx.saved.last_run_created ?? 0) + " bon(s) créé(s) ", 1))
                          : _createCommentVNode("", true),
                        (_ctx.saved.last_run_error)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_35, "Erreur : " + _toDisplayString(_ctx.saved.last_run_error), 1))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ], 32))
            ])
          ]),
          _cache[29] || (_cache[29] = _createStaticVNode("<div class=\"apm-rules\" data-v-99c6c53e><strong data-v-99c6c53e>Règles communes</strong><span data-v-99c6c53e><i class=\"ph-fill ph-check-circle\" aria-hidden=\"true\" data-v-99c6c53e></i>Un bon par livreur</span><span data-v-99c6c53e><i class=\"ph-fill ph-check-circle\" aria-hidden=\"true\" data-v-99c6c53e></i>Aucun colis en double</span><span data-v-99c6c53e><i class=\"ph-fill ph-check-circle\" aria-hidden=\"true\" data-v-99c6c53e></i>Aucun bon vide</span></div><p class=\"apm-foot\" data-v-99c6c53e>Création uniquement • Enregistrer et Payer restent manuels</p>", 2))
        ])
      ])
    ])
  ], 512))
}